import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { Cart } from "../_models/index";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";
import {
  NgbModal,
  NgbModalOptions,
  ModalDismissReasons,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  moduleId: module.id,
  selector: "cart",
  templateUrl: "cart.component.html",
  styleUrls: ["cart.component.scss"],
})
export class CartComponent implements OnInit {
  @Output() checkoutAction: EventEmitter<void> = new EventEmitter<void>();
  cart: Cart;
  numberOfPayments: any;
  payments: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  modalInfoReferenceCart: any;
  modalDebugInfoCart: any;

  constructor(
    private router: Router,
    private dataService: DataService,
    private alertService: AlertService,
    private modalService: NgbModal
  ) {}

  public removeFromCart(item) {
    item.isInCart = false;
    this.dataService.removeFromCart(item).subscribe((data) => {
      this.cart = data;
    });
  }

  open(childId, eventId) {
    this.router.navigate(["/event/" + childId + "/" + eventId]);
  }

  checkout() {
    this.checkoutAction.emit();

    //     	this.router.navigate(['/checkout']);
    //     	if (!this.numberOfPayments){
    //     		this.alertService.error('כמה תשלומים');
    //     	}
    //     	else{
    //     		this.dataService.checkout({numberOfPayments:this.numberOfPayments}).subscribe(
    //                 data => {
    //
    // 					if (data && data.redirect)
    // 						window.location.href = data.redirect;
    //                 },
    //                 error => {
    //                     this.alertService.error(error);
    //                 });
    //     	}
  }

  public openInfoModalCart(content, debugInfo) {
    if (debugInfo) {
      this.modalDebugInfoCart = debugInfo;
      let options: NgbModalOptions = { windowClass: "modal-info-opened" };
      this.modalInfoReferenceCart = this.modalService.open(content, options);
    }
  }

  ngOnInit() {
    this.loadAllData();
  }

  private loadAllData() {
    this.cart = JSON.parse(localStorage.getItem("cart"));

    this.dataService.cart.subscribe((nextVal) => {
      this.cart = nextVal;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/cart/cart.component.ts